import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block2-箭头-展开.png")